import { ReactComponent as InfoCircle } from "@/assets/svgs/info-circle.svg";
import Button from "@/components/Button/index";
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import rem from "@/utils/rem";
import PropTypes from "prop-types";

const DisableEtrIssuance = ({ "data-testid": dataTestId = 'etr-issuance', visible, hide, handleSubmit, body }) => {
	return (
		<Modal visible={visible} variant="small" close={hide}>
			<CardConfigure
				addHeaderClass="eap-modal__header"
			>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__rounded-square card-configure__icon--error'}>
										<div className="tnc-modal__icon">
											<InfoCircle />
										</div>
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Disabling ETR Issuance
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						{body ?? <div>
							<div className="etr-issuance-modal__content center">
								<p>
									Are you sure you want to disable ETR
									issuance?
								</p>
								<p>
									Disabling ETR Issuance will
									disable the ability to issue ETR.
								</p>
							</div>
						</div>}
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<div className="tnc-modal__confirmation_actions">
							<Button
								data-testid={`${dataTestId}-cancel`}
								ghost
								round
								noborder
								reject
								submit={() => hide()}
								text="Cancel"
							/>
							<Button
								data-testid={`${dataTestId}-confirm`}
								full
								round
								error
								submit={() => {
									handleSubmit()
									hide()
								}}
								text="Confirm"
							/>
						</div>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	);
};

DisableEtrIssuance.propTypes = {
	"data-testid": PropTypes.string,
	visible: PropTypes.bool,
	hide: PropTypes.func,
	handleSubmit: PropTypes.func,
	body: PropTypes.node,
};

export default DisableEtrIssuance;
